import { useState, useEffect, useCallback } from 'react';
import useFetchWithMsal from './useFetchWithMsal';
import { loginRequest, protectedResources } from "../authConfig";
import { ISkillPath } from '../model/SkillPath.model';
import { ISkillLevel } from '../model/SkillLevel.model';


export function useGetSkillLevelsOData(odataString:string, externalLoading: boolean | null | ISkillPath) {
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.read,
    });
    const [loading, setLoading] = useState(true);
    const [callErr, setErr] = useState(null);
    const [skillLevels, setSLData] = useState(null)
    const [odataStringSt, setOdataStringSt] = useState("");
  
  console.log('setup use SL odata', odataString);
    useEffect(() => {
      console.log('effect SL odata', odataString, externalLoading);
      //setSLData(null);
      let odataStringEnc = encodeURIComponent(odataString);
      if (!externalLoading && (odataStringSt!==odataString || skillLevels===null)) {
        execute("GET", `/api/SkillLevel/odata/${odataStringEnc}`)
        .then(response => {
          setSLData(response);
          console.log('new level data', response);
          setLoading(false);
          setOdataStringSt(odataString);
        }).catch(err => {
          setErr(err);
          setLoading(false);
        })
      }
    }, [execute, skillLevels, odataString, externalLoading, odataStringSt]);
    if (skillLevels===null) return [null, true];
    return [skillLevels as ISkillLevel[], loading, error, callErr];
  }